import React, { useState, useEffect } from "react";
import {
  Button,
  IconButton,
  Paper,
  Typography,
  Divider,
  DialogActions,
  Grid,
  TextField,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import EventNote from "@material-ui/icons/EventNote";
import serviciosTablero from "utils/serviciosTablero";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import RelojAnalogico from "./RelojAnalogico";
import Autocomplete from "@material-ui/lab/Autocomplete";

const Fechas = ({
  open,
  onClose,
  setCargando,
  setMensaje,
  idtarjeta,
  onFechaChange,
}) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateOld, setStartDateOld] = useState(null);
  const [endDateOld, setEndDateOld] = useState(null);
  const [eventoFechas, setEventoFechas] = useState(false);
  const [isStartCalendarOpen, setStartCalendarOpen] = useState(false);
  const [isEndCalendarOpen, setEndCalendarOpen] = useState(false);
  const classesTablero = useStylesTablero();
  const [fecha, setFecha] = useState([]);
  const [motivosCambios, setMotivosCambios] = useState([]);
  const [errors, setErrors] = useState({});

  const [motivo, setMotivo] = useState("");

  // Cambia el mes actual
  const changeMonth = (offset) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + offset);
    setCurrentDate(newDate);
  };

  // Maneja la selección de una fecha
  const handleDateSelect = (date, type) => {
    if (type === "start") {
      setStartDate(date);
      delete errors.startDate;
      setStartCalendarOpen(false);
    } else {
      if (startDate && date < startDate) {
        setMensaje({
          open: true,
          status: -1,
          value: "La fecha de fin no puede ser anterior a la fecha de inicio.",
        });
        return;
      }

      setEndDate(date);
      delete errors.endDate;
      setEndCalendarOpen(false);
    }
  };

  // Renderiza los días del calendario
  const renderDays = (type) => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDayOfMonth = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    const days = [];

    // Días vacíos al inicio
    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push(<div key={`empty-${i}`} style={{ flex: "1 0 14%" }}></div>);
    }

    // Días del mes
    for (let day = 1; day <= daysInMonth; day++) {
      const isSelected =
        (type === "start" &&
          startDate &&
          startDate.getDate() === day &&
          startDate.getMonth() === month) ||
        (type === "end" &&
          endDate &&
          endDate.getDate() === day &&
          endDate.getMonth() === month);
      const isToday =
        new Date().toDateString() === new Date(year, month, day).toDateString();

      days.push(
        <div
          key={day}
          onClick={() => handleDateSelect(new Date(year, month, day), type)}
          style={{
            flex: "1 0 14%",
            padding: "10px",
            margin: "4px",
            textAlign: "center",
            borderRadius: "50%",
            cursor: "pointer",
            backgroundColor: isSelected
              ? "#ffcc00"
              : isToday
              ? "#4e5660"
              : "transparent",
            color: isSelected ? "#323940" : "#fff",
          }}
        >
          {day}
        </div>
      );
    }

    return days;
  };

  const validateFechas = () => {
    let errorsForm = {};
    let mensajeError = "Campo requerido.";

    if (!startDate) errorsForm["startDate"] = mensajeError;
    if (!endDate) errorsForm["endDate"] = mensajeError;

    setErrors(errorsForm);

    return Object.keys(errorsForm).length === 0 ? true : false;
  };

  const handleGuardarFecha = () => {
    if (!validateFechas()) return;

    let fechaInicio = `${startDate?.getFullYear()}-${startDate?.getMonth() +
      1}-${startDate?.getDate()}`;
    let fechaFin = `${endDate?.getFullYear()}-${endDate?.getMonth() +
      1}-${endDate?.getDate()}`;

    if (!fechaInicio || !fechaFin) {
      setMensaje({
        open: true,
        status: -1,
        value: "Error al cargar las fechas, por favor vuelva a intentarlo.",
      });
    }

    serviciosTablero.updateTituloTarjeta(
      (estatus, mensaje, response) => {
        setMensaje({ open: true, status: estatus, value: mensaje });
        if (estatus > 0) {
          onFechaChange(response);
          onClose();
        }
      },
      setCargando,
      { idtarjeta: idtarjeta, finicio: fechaInicio, ffin: fechaFin }
    );
  };

  const validateSolicitud = () => {
    let errorsForm = {};
    let mensajeError = "Campo requerido.";

    if (startDateOld ? false : !startDate)
      errorsForm["startDate"] = mensajeError;
    if (!endDate) errorsForm["endDate"] = mensajeError;
    if (!motivo) errorsForm["motivo"] = mensajeError;
    if (endDate && endDateOld && endDate <= endDateOld)
      errorsForm["endDate"] =
        "La nueva fecha de finalización debe ser mayor o diferente que la anterior.";

    setErrors(errorsForm);

    return Object.keys(errorsForm).length === 0 ? true : false;
  };

  const handleSolicitarCambio = () => {
    if (!validateSolicitud()) return;

    let fechaInicioOld = `${startDateOld?.getFullYear()}-${startDateOld?.getMonth() +
      1}-${startDateOld?.getDate()}`;
    let fechaFinOld = `${endDateOld?.getFullYear()}-${endDateOld?.getMonth() +
      1}-${endDateOld?.getDate()}`;
    let fechaInicio = startDate
      ? `${startDate?.getFullYear()}-${startDate?.getMonth() +
          1}-${startDate?.getDate()}`
      : startDateOld;
    let fechaFin = `${endDate?.getFullYear()}-${endDate?.getMonth() +
      1}-${endDate?.getDate()}`;

    let datos = {
      idtarjeta: idtarjeta,
      tipofecha: 1,
      finicio_anterior: fechaInicioOld,
      ffin_anterior: fechaFinOld,
      finicio_nuevo: fechaInicio,
      ffin_nuevo: fechaFin,
      idmotivo: motivo,
    };
    serviciosTablero.createSolicitudCambioFecha(
      (estatus, mensaje, data) => {
        setMensaje({ open: true, status: estatus, value: mensaje });
        if (estatus == 1) {
          onClose();
          onFechaChange(data, 1);
        }
      },
      setCargando,
      datos
    );
  };

  const getFechas = () => {
    serviciosTablero.getTarjetaData(
      (estatus, mensaje, data) => {
        if (estatus > 0) {
          if (data.general.finicio && data.general.ffin) {
            let fechaInicio = new Date(data.general.finicio);
            let fechaFinal = new Date(data.general.ffin);

            setEventoFechas(true);
            setStartDateOld(fechaInicio);
            setEndDateOld(fechaFinal);
            setMotivosCambios(data.motivos);
          }
        }
      },
      setCargando,
      { idtarjeta: idtarjeta }
    );
  };

  useEffect(() => {
    if (open) {
      getFechas();
    }
  }, [open]);
  return (
    <div>
      {!eventoFechas ? (
        <Grid container>
          {/* Fecha de Inicio */}
          <Grid item xs={12} sm={12} spacing={2}>
            <Grid>
              <Typography>Fecha de inicio:</Typography>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => setStartCalendarOpen(!isStartCalendarOpen)}
                className={classesTablero.btnFecha}
                endIcon={<EventNote />}
                style={errors?.startDate ? { borderColor: "red" } : {}}
              >
                {startDate
                  ? startDate.toLocaleDateString("es-ES", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })
                  : "Selecciona una fecha"}
              </Button>
              {errors?.startDate && (
                <Typography variant="caption" style={{ color: "#f44336" }}>
                  {errors?.startDate}
                </Typography>
              )}
              {isStartCalendarOpen && (
                <Paper
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "#323940",
                    padding: "20px",
                    zIndex: 1000,
                    color: "#fff",
                    width: "300px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <IconButton
                      onClick={() => changeMonth(-1)}
                      style={{ color: "#fff" }}
                    >
                      <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" style={{ color: "#fff" }}>
                      {currentDate.toLocaleDateString("es-ES", {
                        month: "long",
                        year: "numeric",
                      })}
                    </Typography>
                    <IconButton
                      onClick={() => changeMonth(1)}
                      style={{ color: "#fff" }}
                    >
                      <ArrowForwardIcon />
                    </IconButton>
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {renderDays("start")}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                    }}
                  >
                    <Button
                      variant="outlined"
                      style={{
                        color: "#fff",
                        borderColor: "#555",
                        marginRight: "10px",
                      }}
                      onClick={() => setStartCalendarOpen(false)}
                    >
                      Cancelar
                    </Button>
                  </div>
                </Paper>
              )}
            </Grid>

            {/* Fecha de Fin */}
            <Grid>
              <Typography>Fecha de término</Typography>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => setEndCalendarOpen(!isEndCalendarOpen)}
                className={classesTablero.btnFecha}
                endIcon={<EventNote />}
                style={errors?.endDate ? { borderColor: "red" } : {}}
              >
                {endDate
                  ? endDate.toLocaleDateString("es-ES", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })
                  : "Selecciona una fecha"}
              </Button>
              {errors?.endDate && (
                <Typography variant="caption" style={{ color: "#f44336" }}>
                  {errors?.endDate}
                </Typography>
              )}
              {isEndCalendarOpen && (
                <Paper
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "#323940",
                    padding: "20px",
                    zIndex: 1000,
                    color: "#fff",
                    width: "300px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <IconButton
                      onClick={() => changeMonth(-1)}
                      style={{ color: "#fff" }}
                    >
                      <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" style={{ color: "#fff" }}>
                      {currentDate.toLocaleDateString("es-ES", {
                        month: "long",
                        year: "numeric",
                      })}
                    </Typography>
                    <IconButton
                      onClick={() => changeMonth(1)}
                      style={{ color: "#fff" }}
                    >
                      <ArrowForwardIcon />
                    </IconButton>
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {renderDays("end")}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                    }}
                  >
                    <Button
                      variant="outlined"
                      style={{
                        color: "#fff",
                        borderColor: "#555",
                        marginRight: "10px",
                      }}
                      onClick={() => setEndCalendarOpen(false)}
                    >
                      Cancelar
                    </Button>
                  </div>
                </Paper>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            {/* <RelojAnalogico /> */}
          </Grid>

          {/* Botón de Agregar */}
          <Grid item xs={12} sm={12} style={{ marginTop: 6 }}>
            <DialogActions style={{ justifyContent: "flex-end" }}>
              <Button className={classesTablero.btnCancelar} onClick={onClose}>
                Cancelar
              </Button>
              <Button
                className={classesTablero.btnAceptar}
                onClick={handleGuardarFecha}
              >
                Agregar
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
      ) : (
        <Grid container>
          <Typography>Fecha de inicio</Typography>
          <Button
            variant="outlined"
            fullWidth
            className={classesTablero.btnFecha}
            endIcon={<EventNote />}
            disabled
          >
            {startDateOld?.toLocaleDateString("es-ES", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </Button>
          <Typography>Fecha de término anterior:</Typography>
          <Button
            variant="outlined"
            fullWidth
            className={classesTablero.btnFecha}
            endIcon={<EventNote />}
            disabled
          >
            {endDateOld?.toLocaleDateString("es-ES", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </Button>

          <Grid
            item
            xs={12}
            sm={12}
            spacing={3}
            style={{ marginTop: "15px", marginBottom: "15px" }}
          >
            <Divider style={{ backgroundColor: "gray" }} />
          </Grid>

          {/* PARTE DE BOTONES DE FECHAS */}
          <Grid item xs={12} sm={12} spacing={2}>
            {/* Fecha de Fin */}
            <Grid>
              <Typography>Nueva fecha de término</Typography>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => setEndCalendarOpen(!isEndCalendarOpen)}
                className={classesTablero.btnFecha}
                endIcon={<EventNote />}
                style={errors?.endDate ? { borderColor: "red" } : {}}
              >
                {endDate
                  ? endDate.toLocaleDateString("es-ES", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })
                  : "Selecciona una fecha"}
              </Button>
              {errors?.endDate && (
                <Typography variant="caption" style={{ color: "#f44336" }}>
                  {errors?.endDate}
                </Typography>
              )}
              {isEndCalendarOpen && (
                <Paper
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "#323940",
                    padding: "20px",
                    zIndex: 1000,
                    color: "#fff",
                    width: "300px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <IconButton
                      onClick={() => changeMonth(-1)}
                      style={{ color: "#fff" }}
                    >
                      <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" style={{ color: "#fff" }}>
                      {currentDate.toLocaleDateString("es-ES", {
                        month: "long",
                        year: "numeric",
                      })}
                    </Typography>
                    <IconButton onClick={() => changeMonth(1)}>
                      <ArrowForwardIcon />
                    </IconButton>
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {renderDays("end")}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                    }}
                  >
                    <Button
                      variant="outlined"
                      style={{
                        color: "#fff",
                        borderColor: "#555",
                        marginRight: "10px",
                      }}
                      onClick={() => setEndCalendarOpen(false)}
                    >
                      Cancelar
                    </Button>
                  </div>
                </Paper>
              )}
            </Grid>
          </Grid>
          <Autocomplete
            fullWidth
            options={motivosCambios}
            getOptionLabel={(option) => option.nmotivo}
            onChange={(event, value) => {
              delete errors.motivo;
              setMotivo(value?.idmotivo || "");
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="SELECCIONA UN MOTIVO"
                variant="outlined"
                className={classesTablero.field}
                fullWidth
                style={{ marginTop: 8 }}
              />
            )}
            // freeSolo // Permite escribir un motivo personalizado
          />
          {errors?.motivo && (
            <Typography variant="caption" style={{ color: "#f44336" }}>
              {errors?.motivo}
            </Typography>
          )}

          <Grid item xs={12} sm={12} style={{ marginTop: 6 }}>
            <DialogActions style={{ justifyContent: "flex-end" }}>
              <Button className={classesTablero.btnCancelar} onClick={onClose}>
                Cancelar
              </Button>
              <Button
                className={classesTablero.btnAceptar}
                onClick={handleSolicitarCambio}
              >
                Solicitar cambio
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default Fechas;
